import type { TechniqueEntry } from '../schema';

export const functionOfUseDescent: TechniqueEntry = {
  key: 'function_of_use_descent',
  version: '0.2',
  name: 'Function-of-use descent',
  pillar: 'MI',
  serves:
    'Understanding what the substance or behaviour actually does for the member (the need it meets, the feeling it produces or numbs) when only the surface reason (relaxing, unwinding, switching off) is in the room. Function and meaning, not episode analysis.',
  method: [
    "Treat surface answers as doorways, not destinations. Descend one layer at a time, composing every question fresh in the member's own vocabulary, no stock phrasings, and never the same phrasing twice in one conversation.",
    'Each question takes one angle from a small set: what the use hands them in that moment; which part of that they would most hate to lose; what is building in them just before the pull arrives; what the use stands between them and; what would have to be true for them to no longer need it. One angle per turn.',
    'Alternate question and reflection; never stack questions. Catch each new layer with an amplified reflection rather than another question: restate what they said slightly stronger and slightly more specific than they put it, so they correct you toward precision: the correction is the descent.',
    'A run of near-identical digging questions turns the exercise into a quiz; reflections turn it into a thread the member keeps pulling. Track their own words for the function, the deeper need, and when the pull shows up.',
  ],
  never: [
    'Do not walk them through a specific event step by step (that is functional analysis, a different move).',
    'Do not accept the first answer as the bottom.',
    'Do not keep laddering on a member gone flat or two-word; route to compress-and-close instead.',
    'No change-steering while descending.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause:
        'Member engaged and still bringing material (persistence is for an engaged member, not one winding down).',
    },
  ],
  doneWhen:
    'One of: (a) a core need named: relief, safety, control, escape, numbness, connection, feeling like enough, being off the hook; (b) their affect shifts: they slow down, go quiet, say "huh", correct themselves, get emotional, or land on something clearly never said aloud before; (c) they circle the same underlying thing twice in different words. The affect shift is bedrock: trust it over any turn count.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source: 'shared/sections/practice_objective.md (Movement A), practice_guidelines.md',
};
